import { Menu } from "@mantine/core";
import { Trophy } from "lucide-react";
import type { CSSProperties } from "react";

import type { AchievementBoard, UnseenAward } from "../../api/generated/model";
import classes from "./achievements.module.css";
import { Badge } from "./Badge";
import { TIER_NAME, tierColor } from "./words";

/**
 * The gift menu's achievements (spec web/achievements, 3): the unlocks the menu opened with, under a
 * heading that counts them (decision 12), newest first, each with its badge, tier and roast, and
 * the Achievements tab; with none, the tab alone.
 */
export function AchievementsEntry({
  board,
  listed,
  onOpenTab,
}: {
  board: AchievementBoard;
  listed: readonly UnseenAward[];
  onOpenTab: () => void;
}) {
  const unlocks = listed.flatMap((award) => {
    const view = board.achievements.find((each) => each.id === award.achievement_id);
    return view === undefined ? [] : [{ award, view }];
  });
  if (unlocks.length === 0) {
    return (
      <Menu.Item leftSection={<Trophy size={16} />} onClick={onOpenTab}>
        Achievements
      </Menu.Item>
    );
  }
  return (
    <>
      <Menu.Label>
        {unlocks.length} new {unlocks.length === 1 ? "achievement" : "achievements"}
      </Menu.Label>
      {unlocks.map(({ award, view }) => (
        <Menu.Item
          key={award.award_id}
          className={classes.unlock}
          style={{ "--tier": tierColor(view.tier) } as CSSProperties}
          leftSection={<Badge tier={view.tier} glyph={view.glyph} state="earned" size={40} />}
          onClick={onOpenTab}
        >
          <span className={classes.unlockName}>{view.name}</span>
          <span className={classes.unlockTier}>{TIER_NAME[view.tier]}</span>
          <span className={classes.unlockRoast}>{view.description}</span>
        </Menu.Item>
      ))}
      <Menu.Item leftSection={<Trophy size={16} />} onClick={onOpenTab}>
        See all achievements
      </Menu.Item>
    </>
  );
}
